import React from "react";
import styled from "styled-components";

import LineSeedKrBd from "../../../../atoms/text/lineSeedKr/lineSeedKrBd";

const LSBdDisplay03 = (props) => {
  return <LSBdDisplay03Wrapper {...props} />;
};

export default LSBdDisplay03;

const LSBdDisplay03Wrapper = styled(LineSeedKrBd)`
  font-size: 32px;
  font-weight: 700;
  line-height: 44.8px;
  letter-spacing: -0.6px;

  color: #222222;
`;
